import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { EventItemComponent } from '../event-item/event-item.component';

@Component({
  selector: 'app-view-table-row-detail',
  templateUrl: './view-table-row-detail.component.html',
  styleUrls: ['./view-table-row-detail.component.scss'],
})
export class ViewTableRowDetailComponent implements OnInit {
@Input() data: any;
@Input() columnData: any;
@Input() PageName: any;
@Input() addItemsData?: any=null;
@Input() editableForm: boolean=false;
approval: string | null = null;
  approvalComment: string = '';
  public awdbSub: Subscription;
  record: any;
  rows: any[][] = [];
  showAddEventItemForm:boolean = false
  isLoading:boolean = false
  constructor(private modalController: ModalController,private apiService:ApiService) { }

  ngOnInit() {
    this.approval = this.data?.approvalStatus
    this.approvalComment = this.data?.comment
    console.log(this.approval)
    this.changeColumnsNumber()
  }

  changeColumnsNumber(){
    if(this.addItemsData){
      this.rows = this.chunkArray(this.columnData, 2); // Change 4 to 5 if needed
    }
    else{
      this.rows = this.chunkArray(this.columnData, 4); // Change 4 to 5 if needed
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  chunkArray(data: any[], size: number): any[][] {
    const result = [];
    for (let i = 0; i < data.length; i += size) {
      result.push(data.slice(i, i + size));
    }
    return result;
  }

  trackByIndex(index: number): number {
    return index;
  }

public statusListDialogObj;
  public onOpenStatusListDeleteDialog = function (): void {
    this.statusListDialogObj = DialogUtility.confirm({
      title: 'Delete Confirmation',
      content: 'Delete selected Maintenance Task?',
      okButton: { text: 'OK', click: this.okStatusListClick.bind(this) },
      cancelButton: { text: 'Cancel', click: this.cancelStatusListClick.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' }
    });
  };

  private okStatusListClick(): void {
    try {
      this.awdbSub = this.apiService.deleteStatusList(this.data?.assetMaintenanceMappingId).subscribe((data1) => {
        this.modalController.dismiss({
                'dismissed': true
              });
        this.statusListDialogObj.hide();
        this.apiService.openSnackBar("Data Deleted Successfully");
      }, (err: any) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      }), (err: any) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
    }
  }

  private cancelStatusListClick(): void {
    //Hide the dialog
    this.statusListDialogObj.hide();
  }

  public ngOnDestroy(): void {
    if (this.awdbSub !== null && this.awdbSub !== undefined) {
      this.awdbSub.unsubscribe();
    }
  }
  onApprovalChange(event: any) {
    this.approval = event.value;
    this.approvalComment = '';
  }

  onApprovalCommentChange(event: any) {
    this.approvalComment = event.target.value;
  }
  async saveItem() {

    if (this.addItemsData.eventId) {
      this.apiService.updateOilEventTaskListStatus({
        eventId: this.addItemsData.eventId,
        assetId: this.addItemsData?.assetObj.assetId,
        assetTypeId: this.addItemsData?.assetObj.assetTypeId,
        assetMaintenanceMappingId: this.addItemsData.assetMaintenanceMappingId,
        approvalStatus: this.approval,
        comment: this.approvalComment
      }).subscribe((res: any) => {
        console.log("Updated event document!", res);
         this.modalController.dismiss({
                'dismissed': true
              });
        this.statusListDialogObj.hide();
      }, (err: any) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      }), (err: any) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      };
    }
  }
  async viewItem() {
    this.isLoading = true
      try {
        (this.apiService.getOilEventItemDataById(this.addItemsData?.eventId,this.addItemsData?.itemId).subscribe(
          (res: any) => {
            if(res?.data?.length>0){
              this.openViewItemModel(res?.data[0])
              this.isLoading = false;
            }
          },
          (err) => {
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
            this.isLoading = false;
          }
        )),
          (err) => {
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
            this.isLoading = false;
          };
      } catch (err) {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
        this.isLoading = false;
      }

      }

      async openViewItemModel(item){
         const modal = await this.modalController.create({
          component: EventItemComponent,
          componentProps: {
            type: 'View',
            item,
            eventId: this.addItemsData?.eventId,
            assetObj: { assetTypeId: this.addItemsData?.assetObj?.assetTypeId, assetId: this.addItemsData?.assetObj?.assetId },
          },
          backdropDismiss: true,
          cssClass: 'item-view-from-event-category',
        });

        modal.onDidDismiss().then(() => {
          modal?.dismiss();
        });

        await modal.present();
      }
}
